import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { commonComponentImages } from '@images/common-components-images';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
  displayBasic = true;
  images = commonComponentImages;

  constructor(private _location: Location) {}

  ngOnInit() {}

  onCloseDialog() {
    this._location.back();
  }
}
